import React, { useState } from 'react';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { Grid, Collapse } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import NaviData from 'data/navi/naviLinkItem.json';
import { useLocation,Link } from "react-router-dom";
import { useNavCtaHref } from 'context/NavCtaContext';
import { startHref } from 'helpers/portalSession';
import { withUtm } from 'helpers/tracking';
import { isPlainLink, isCurrentPage } from 'helpers/navi';

// Jesus is needed here when available

const MobileMenu = () => {
    const getStartedHref = useNavCtaHref(startHref(window.location.search));
    const [anchorEl, setAnchorEl] = useState(null)
    const [openGroup, setOpenGroup] = useState(null) // the one fold open, by its place in the JSON

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const location = useLocation()
    const isCurrent = (url) => isCurrentPage(location.pathname, url, location.search);

    return (
        <div className='nav-mobile-menu'>
            <Button
                className='settingIcon'
                id="mobile-navi-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            ><MenuIcon/></Button>
            <Menu
                id="mobile-menu"
                width='100%'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'mobile-navi-button',
                }}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 35,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
            >
                <Grid container px={3} py={1} width={300} sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <Grid item xs={12}>
                        {/* the same groups as the desktop menu, in the JSON's order: a plain
                            link for a group of one, a fold for the rest; one fold open at a time */}
                        {NaviData.map((group, g) => (isPlainLink(group) ? (
                            <Link key={group.id} to={withUtm(group.list[0].url, location.search)} target={group.list[0].outSource ? '_blank' : ''} rel="noopener noreferrer">
                                <MenuItem divider sx={{ color: 'text.primary' }} onClick={handleClose} selected={isCurrent(group.list[0].url)}>
                                    {group.title}
                                </MenuItem>
                            </Link>
                        ) : (
                            <React.Fragment key={group.id}>
                                <MenuItem
                                    divider
                                    sx={{ color: 'text.primary', justifyContent: 'space-between' }}
                                    aria-expanded={openGroup === g}
                                    onClick={() => setOpenGroup(openGroup === g ? null : g)}>
                                    {group.title}
                                    {openGroup === g ? <ExpandLess fontSize='small' /> : <ExpandMore fontSize='small' />}
                                </MenuItem>
                                <Collapse timeout="auto" unmountOnExit in={openGroup === g}>
                                    <div>
                                        {group.list.map((item) => (
                                            <Link key={item.id} to={withUtm(item.url, location.search)} target={item.outSource ? "_blank" : ''} rel="noopener noreferrer">
                                                <MenuItem divider onClick={handleClose} selected={isCurrent(item.url)}>
                                                    <ListItemText inset sx={{ color: 'text.secondary', fontWeight: 300 }}>{item.text}</ListItemText>
                                                </MenuItem>
                                            </Link>
                                        ))}
                                    </div>
                                </Collapse>
                            </React.Fragment>
                        )))}

                        <a href="https://younet.ai/portal/login" rel="noreferrer" style={{ color: 'var(--ynt-text-strong)' }}>
                            <MenuItem divider onClick={handleClose}>
                                <div>Sign in</div></MenuItem></a>
                        <a href={getStartedHref} rel="noreferrer" style={{ color: 'var(--ynt-text-strong)' }}>
                            <MenuItem onClick={handleClose}>
                                <div>Get Started</div></MenuItem></a>

                    </Grid>
                </Grid>
            </Menu>
        </div>
    )
}

export default MobileMenu;
